import script from "./ModalShowMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalShowMessage.vue?vue&type=script&setup=true&lang=js"

import "./ModalShowMessage.vue?vue&type=style&index=0&id=94d3971a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d3971a"]])

export default __exports__